<template>
  <div>
   <div class="resource-container swiper-container">
                <div class="swiper-wrapper one-wrapper ">
                  <div
                    v-for="(item, index) in organizationsimgs"
                    :key="index"
                    class="resource-slide swiper-slide"
                  >
                    <img
                      :src="item.img"
                      style="height: 80%; width: 100%"
                      alt=""
                    />
                    <p style="color: #0069bf;font-weight: 400;text-align: center;">{{ item.title }}</p>
                  </div>
                </div>
                    <div class="swiper-button-prev">
                  <!-- <i class="el-icon-right"></i> -->
                </div>
                <div class="swiper-button-next">
                  <!-- <i class="el-icon-back"></i> -->
                </div>
            
              </div>
  </div>

</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
export default {
  name: "Products",
  props:{
  //  mobel: {
  //     type: Boolean,
  //     default: false,
  //   },
  },
  data() {
    return {
      mobel:false,
           organizationsimgs: [
        {
          title: "Financial Institutions",
          img: require("../assets/2023/10/fpi-300x300.jpg"),
        },
        {
          title: "Insurance",
          img: require("../assets/2023/10/insurance-300x300.jpg"),
        },
        {
          title: "Investment Management",
          img: require("../assets/2023/10/investment-300x300.jpg"),
        },
        {
          title: "Manufacture",
          img: require("../assets/2023/10/manufacture-300x300.jpg"),
        },
        {
          title: "Trade",
          img: require("../assets/2023/10/trade-300x300.jpg"),
        },
        {
          title: "Professional Services",
          img: require("../assets/2023/10/prof-services-300x300.jpg"),
        },
        {
          title: "Ecommerce",
          img: require("../assets/2023/10/ecommerce-300x300.jpg"),
        },
        {
          title: "Data Management",
          img: require("../assets/2023/10/data-management-300x300.jpg"),
        },
        {
          title: "Education",
          img: require("../assets/2023/10/education-300x300.jpg"),
        },
        {
          title: "Organization",
          img: require("../assets/2023/10/organization-300x300.jpg"),
        },
      ],
    };
  },
  watch: {
      '$route.hash': function() {
        // 在这里可以处理hash变化后的逻辑
      // this.scrollToAnchor()
      }
  },
  methods: {
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
  
      if (screenHeight > 1000) {
        this.mobel = false;
        this.getSwiper()
      } else {
      
        if(screenHeight < 1000){
             this.mobel=true
        // if(screenHeight == 1000){
this.getSwiper()
        // }
       
        
        }
      }
    },
    getSwiper() {
      this.swiper = new Swiper(".resource-container", {
        loop: false, // 无缝
        autoplay: { //自动开始
            delay: 3000, //时间间隔
            disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: this.mobel?2:6, // 一组三个
        spaceBetween: 20, // 间隔
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
        observer: true,
        observeParents: true,
        // 如果需要分页器
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true, // 分页器可以点击
        // },
      });
    },
  },
  mounted() {
    this.getSwiper();
        window.addEventListener('resize', this.menuSeen);
    this.menuSeen();
  },
    beforeDestroy() {
  window.removeEventListener('resize', this.menuSeen);
}
};
</script>

<style scoped>
.swiper-button-next,  .swiper-button-prev {
    /* right: 10px;
    left: auto; */
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: #fff;
    color: black;
}
.swiper-button-prev:after,.swiper-button-next:after{
    font-size: 16px;
}
</style>